import { FormattedMessage } from 'react-intl';
import Dialog from '@rio-cloud/rio-uikit/Dialog';

import type { CloseDialogProps } from '@/features/app/dialogs/types';

const DialogFooter = ({ onClose }: CloseDialogProps) => (
    <Dialog.Footer>
        <button className="btn btn-primary" onClick={onClose}>
            <FormattedMessage id="intl-msg:engineOil.table.detailsDialog.close" />
        </button>
    </Dialog.Footer>
);

export default DialogFooter;
